import React from 'react'
import { Form, TextInput, Button, Icon } from '@cobalt/cobalt-react-components'
import { bool, func, string } from 'prop-types'
import '../../../assets/password-input-field-group.css'

class PasswordInputFieldGroup extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false
    }
  }

  handleShowPassword = () =>
    this.setState({ showPassword: !this.state.showPassword })

  renderTextInput = (
    placeholder,
    password,
    onPasswordChange,
    autoFocus,
    onFocus,
    onBlur
  ) => (
    <TextInput
      value={password}
      onChange={onPasswordChange}
      type={
        this.state.showPassword ? TextInput.TYPE_TEXT : TextInput.TYPE_PASSWORD
      }
      placeholder={placeholder}
      onFocus={onFocus}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  )

  renderVisibilityButton = () => (
    <Button secondary normal onClick={this.handleShowPassword} tabIndex="-1">
      <Icon
        name={this.state.showPassword ? Icon.VISIBILITY_OFF : Icon.VISIBILITY}
        tiny
      />
    </Button>
  )

  render() {
    const {
      label,
      disabledForm,
      placeholder,
      password,
      onPasswordChange,
      autoFocus,
      onFocus,
      onBlur
    } = this.props
    return (
      <Form.FieldGroup label={label} disabled={disabledForm}>
        {this.renderTextInput(
          placeholder,
          password,
          onPasswordChange,
          autoFocus,
          onFocus,
          onBlur
        )}
        <React.Fragment>{this.renderVisibilityButton()}</React.Fragment>
      </Form.FieldGroup>
    )
  }
}

PasswordInputFieldGroup.propTypes = {
  label: string.isRequired,
  disabledForm: bool.isRequired,
  placeholder: string.isRequired,
  onPasswordChange: func.isRequired,
  autoFocus: bool,
  onFocus: func,
  onBlur: func,
  password: string
}

PasswordInputFieldGroup.defaultProps = {
  disabledForm: false,
  autoFocus: false
}

export default PasswordInputFieldGroup
